module.exports = __webpack_public_path__ + "media/images/6-7cdbe35c91c80080654f7157c5093f73.jpg";